<div class="topline">
  <h1>Broker</h1>

  @if (brokers.length > 0) {
    <mat-form-field>
      <mat-label>Current Broker</mat-label>
      <mat-select
        [(value)]="selectedBrokerId"
        (selectionChange)="setBrokerId($event.value)">
        @for (broker of brokers; track broker) {
          <mat-option [value]="broker.id">
            {{ broker.name }} ({{ brokerAgencyCounts[broker.id] || 0 }})
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (brokers.length === 0) {
    <h1>
      {{ brokerName }}
    </h1>
  }
</div>

<app-infoband [items]="info"></app-infoband>

<nav mat-tab-nav-bar [tabPanel]="tabs">
  @for (link of links; track link) {
    <a
      mat-tab-link
      (click)="gotoTab(link)"
      [active]="activeLink?.title === link.title">
      {{ link.title }}
    </a>
  }
</nav>

@if (!selectedBrokerId) {
  <app-inlinemessage
    class="info"
    level="info"
    message="Please select a broker so that you can update their profile, agencies, and products">
  </app-inlinemessage>
}

@if (selectedBrokerId) {
  @if (activeLink?.title === 'Profile') {
    <app-broker-profile
      [companyId]="selectedBrokerId">
    </app-broker-profile>
  }
  @if (activeLink?.title === 'Agencies') {
    <app-broker-agencies
      [companyId]="selectedBrokerId"
      [enabled]="true"
      (countEvent)="setCount('Agencies', $event)">
    </app-broker-agencies>
  }
  @if (activeLink?.title === 'Products') {
    <app-broker-products
      [companyId]="selectedBrokerId"
      [enabled]="true"
      (countEvent)="setCount('Products', $event)">
    </app-broker-products>
  }
}

<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
